// If you're using one of our framework SDK packages, like `@sentry/react`,
// substitute its name for `@sentry/browser` here
import * as Sentry from "@sentry/browser";

if (process.env.RAILS_ENV === "production" || process.env.RAILS_ENV === "staging") {
  Sentry.init({
    dsn: "https://f9af9afaa24e45a39d1e602313abc005@o54706.ingest.sentry.io/117187",
    environment: process.env.RAILS_ENV,

    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["grm.test", "localhost", /^https:\/\/*\.advoc8\.co/],
  });
}
